import { render, staticRenderFns } from "./FTOverview.vue?vue&type=template&id=0c066046&scoped=true&"
import script from "./FTOverview.vue?vue&type=script&lang=js&"
export * from "./FTOverview.vue?vue&type=script&lang=js&"
import style0 from "./FTOverview.vue?vue&type=style&index=0&id=0c066046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c066046",
  null
  
)

export default component.exports